<div class="nav-menu-logo">
  <img src="../../assets/img/logo-checkpad-triosys.png" alt="hospital logo" />
</div>
